import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryContactsFetchFailedAction = {
	type: 'BENEFICIARY_CONTACTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryContactsFetchFailedAction => ({
	type: 'BENEFICIARY_CONTACTS_FETCH_FAILED',
	payload,
});
